<template>
  <report-view :url="downloadUrl">
    <strong>Van:</strong>
    <datepicker v-model="fromDate" :language="datepickerLang" format="dd-MM-yyyy" full-month-name />

    <strong>Tot en met:</strong>
    <datepicker v-model="untilDate" :language="datepickerLang" format="dd-MM-yyyy" full-month-name />
  </report-view>
</template>

<script>
  import RV from '@/components/base/Reportview';
  import Datepicker from 'vuejs-datepicker';
  import { nl } from 'vuejs-datepicker/dist/locale';

  const _minas = {
    name: 'Minas',
    data() {
      return {
        fromDate: new Date((new Date() - 365 * 24 * 60 * 60 * 1000)),
        untilDate: new Date(),
        datepickerLang: nl
      };
    },
    computed: {
      downloadUrl() {
        return `/Report/Minas?from=${this.fromDate.toISOString()}&until=${this.untilDate.toISOString()}`;
      }
    },
    components: {
      'report-view': RV,
      Datepicker
    }
  };

  export default _minas;
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/reports/Minas.vue